import { render, staticRenderFns } from "./InputRang.vue?vue&type=template&id=70c231ac&scoped=true&"
import script from "./InputRang.vue?vue&type=script&lang=js&"
export * from "./InputRang.vue?vue&type=script&lang=js&"
import style0 from "./InputRang.vue?vue&type=style&index=0&id=70c231ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c231ac",
  null
  
)

export default component.exports